import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  class: "ErrorModal"
}
const _hoisted_2 = {
  key: 0,
  class: "ErrorDetails"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "ErrorDetails"
}
const _hoisted_5 = {
  key: 2,
  class: "ErrorDetails"
}
const _hoisted_6 = {
  key: 3,
  class: "ErrorDetails"
}
const _hoisted_7 = {
  key: 4,
  class: "ErrorDetails"
}
const _hoisted_8 = { class: "ErrorDetailsRow" }
const _hoisted_9 = {
  key: 0,
  class: "ErrorDetailsRow"
}
const _hoisted_10 = {
  key: 5,
  class: "ErrorDetails"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("p", null, [
      _createElementVNode("i", { class: "lnr-notification-circle ErrorModalIcon" })
    ], -1 /* CACHED */)),
    (_ctx.errorIsRelatedToUnsupportedCampaignSetting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", {
            class: "ErrorDetailsRow",
            innerHTML: _ctx.invalidCampaignPropertyMessage
          }, null, 8 /* PROPS */, _hoisted_3),
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "ErrorDetailsRow" }, " You'll be taken to the home page of UniAdmin. ", -1 /* CACHED */)),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
            class: "DriverButton InvalidCampaignPropertyRedirectButton"
          }, " Okay ")
        ]))
      : (_ctx.errorIsRelatedToLoadingGeotargetingWhenStandAlone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " The geotargeting flow cannot be accessed unless the campaign editor is viewed in the context of UniversityAdmin. "))
        : (_ctx.errorIsRelatedToACustomProductsOnlyCampaignPageView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " This page is not relevant for custom-product-only campaigns. You'll be taken to the general tab. "))
          : (_ctx.errorIsRelatedToCustomProductDateOutOfBounds)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " One or more custom products have a delivery date outside of the new campaign start and end date. Please update the campaign dates or the custom product dates so they line up, then try again. "))
            : (_ctx.errorIsRelatedToCreateFailedOnDuplicateEntry || _ctx.errorIsRelatedToSaveFailedOnDuplicateEntry)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, " The " + _toDisplayString(_ctx.errorIsRelatedToCreateFailedOnDuplicateEntry ? 'campaign creation' : 'save') + " was unsuccessful. A campaign with the name \"" + _toDisplayString(_ctx.duplicateEntryCampaignDetails?.name) + "\" and the start date \"" + _toDisplayString(_ctx.duplicateEntryStartDateShort) + "\" already exists. ", 1 /* TEXT */),
                  (_ctx.duplicateEntryCampaignDetails)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                        _createElementVNode("button", {
                          class: "Textlink DuplicateEntryRedirectButton",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToTheDuplicateEntry && _ctx.redirectToTheDuplicateEntry(...args)))
                        }, " Go to campaign " + _toDisplayString(_ctx.duplicateEntryCampaignDetails.id), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_10, [
                  (_ctx.errorIsRelatedToInvalidCampaignId)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" The page url is not valid. Please choose a valid campaign ID and reload the page. ")
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.errorIsRelatedToGetGeneralCampaignData)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" The general campaign details could not be fetched. ")
                            ], 64 /* STABLE_FRAGMENT */))
                          : (_ctx.errorIsRelatedToGetAccountManagers)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" The account manager dropdown could not be populated. ")
                              ], 64 /* STABLE_FRAGMENT */))
                            : (_ctx.errorIsRelatedToGetClientServicesPeople)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(" The client services dropdown could not be populated. ")
                                ], 64 /* STABLE_FRAGMENT */))
                              : (_ctx.errorIsRelatedToSearchOrganisations)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createTextVNode(" The organisations that match your search could not be fetched. ")
                                  ], 64 /* STABLE_FRAGMENT */))
                                : (_ctx.errorIsRelatedToGetCustomProducts)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      _createTextVNode(" The custom products could not be fetched. ")
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : (_ctx.errorIsRelatedToGetCampaignReadinessInfo)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                        _createTextVNode(" The \"campaign readiness\" indicator could not be updated. ")
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : (_ctx.errorIsRelatedToGetCampaignListingEntities)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                          _createTextVNode(" The listing entities could not be fetched. ")
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : (_ctx.errorIsRelatedToGetRightsUsers)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                            _createTextVNode(" The list of users with access could not be fetched. ")
                                          ], 64 /* STABLE_FRAGMENT */))
                                        : (_ctx.errorIsRelatedToSearchRightsUsers)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                              _createTextVNode(" The users that match the provided search query could not be fetched. ")
                                            ], 64 /* STABLE_FRAGMENT */))
                                          : (_ctx.errorIsRelatedToGetAuditorEntries)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                                _createTextVNode(" The auditor entries could not be fetched. ")
                                              ], 64 /* STABLE_FRAGMENT */))
                                            : (_ctx.errorIsRelatedToGetPricingProducts)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                                                  _createTextVNode(" The names of pricing products in the auditor table could not be displayed. ")
                                                ], 64 /* STABLE_FRAGMENT */))
                                              : _createCommentVNode("v-if", true),
                        _cache[3] || (_cache[3] = _createTextVNode(" Please reload the page. If the problem persists, please contact the Product Team. ", -1 /* CACHED */))
                      ], 64 /* STABLE_FRAGMENT */))
                ]))
  ], 512 /* NEED_PATCH */))
}